import { createTheme } from '@mui/material';
import StyleExports from './StyleExports.module.scss';

const lightTheme = createTheme({
    palette: { mode: 'light' },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: StyleExports.rowLightGrey,
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    paddingTop: '0px',
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&.unfolded': {
                        backgroundColor: StyleExports.rowLightNav,
                    },
                    '&.active': {
                        backgroundColor: StyleExports.dedalusLightGreen,
                        '&:hover': {
                            backgroundColor: StyleExports.dedalusAzure,
                        },
                    },
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    padding: '6px 12px',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: StyleExports.dobcoBackGrey,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    '&.customButton': {
                        color: 'black',
                        '&:hover': {
                            backgroundColor: StyleExports.dobcoBackGrey,
                        },
                    },
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#334a45',
                    color: 'white',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                    '&:nth-child(2n+1)': {
                        backgroundColor: 'rgba(255, 255, 255, .035)',
                    },
                    '&:hover': {
                        backgroundColor: StyleExports.dedalusAzure,
                        color: 'white',
                    },
                },
            },
        },
    },
    typography: {
        fontSize: 12,
        body1: {
            lineHeight: 1,
        },
    },
});

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: StyleExports.dobcoVeryDarkBlue,
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    paddingTop: '0px',
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: StyleExports.fontColor,
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: StyleExports.dobcoVeryDarkBlue,
                    },
                    '&.unfolded': {
                        backgroundColor: StyleExports.dobcoDarkGreen,
                    },
                    '&.active': {
                        backgroundColor: StyleExports.dobcoDarkGreenHover,
                        '&:hover': {
                            backgroundColor: StyleExports.dobcoGreenMedium,
                        },
                    },
                    '&.inactive': {
                        '&:hover': {
                            backgroundColor: StyleExports.dobcoBlueLight,
                        },
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: StyleExports.dobcoFontWhite,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    color: StyleExports.dobcoFontWhite,
                    backgroundColor: StyleExports.dobcoDarkBlue,
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    backgroundColor: StyleExports.dobcoDarkBlue,
                },
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    backgroundColor: StyleExports.dobcoVeryDarkBlue,
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                    '&:nth-child(2n+1)': {
                        backgroundColor: 'rgba(255, 255, 255, .035)',
                    },
                    '&:hover': {
                        backgroundColor: StyleExports.dobcoDarkGreen,
                    },
                    '&.loading': {
                        cursor: 'default',
                        backgroundColor: 'inherit',
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    color: StyleExports.fontColor,
                    border: '0px',
                },
                head: {
                    backgroundColor: StyleExports.dobcoVeryDarkBlue,
                    color: StyleExports.dobcoGreen,
                },
            },
        },
        MuiGrid: {
            styleOverrides: {
                container: {
                    color: StyleExports.fontColor,
                    backgroundColor: StyleExports.dobcoVeryDarkBlue,
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    backgroundColor: StyleExports.dobcoVeryDarkBlue,
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    padding: '6px 12px',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: StyleExports.dobcoDarkBlue,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    '&.customButton': {
                        color: 'white',
                        '&:hover': {
                            backgroundColor: StyleExports.dobcoBlueLight,
                        },
                    },
                },
            },
        },
    },
    typography: {
        fontSize: 12,
        body1: {
            lineHeight: 1,
        },
    },
});

export { darkTheme, lightTheme };

